import { render, staticRenderFns } from "./BitQMusei.vue?vue&type=template&id=471f63a6&scoped=true"
import script from "./BitQMusei.vue?vue&type=script&lang=js"
export * from "./BitQMusei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f63a6",
  null
  
)

export default component.exports